const icons = [
{name:'pas-icon-true',href:'assets/svg/true.svg'},
{name:'pas-icon-false',href:'assets/svg/false.svg'},
{name:'pas-icon-activity_zone',href:'assets/svg/activity_zone.svg'},
{name:'pas-icon-change',href:'assets/svg/change.svg'},
{name:'pas-icon-delete',href:'assets/svg/delete.svg'},
{name:'pas-icon-attach_file_add',href:'assets/svg/attach_file_add.svg'},
{name:'pas-icon-email',href:'assets/svg/email.svg'},
] as const;
export default icons;
